import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { UseService } from '../../actions/homeAction';
import textWeight from '../../utils/textWeight';

export default () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [currentPage, setCurrentPage] = useState(1);
  const [totalItems, setTotalItems] = useState(0);
  const { data: service, isLoading, isError, error } = UseService(currentPage, 3);
  const { TextWeight } = textWeight();
  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
  };

  useEffect(() => {
    const newTotalItems = service?.pagination?.totalItems;
    if (newTotalItems && newTotalItems !== totalItems) {
      setTotalItems(newTotalItems);
    }
    if (service?.data?.length === 0 && currentPage > 1) {
      setCurrentPage(1);
    }
  }, [service, totalItems, currentPage]);

  if (isError) {
    return <div>Error: {error.message}</div>;
  }
  const handleButtonClick = (_id) => {
    dispatch({
      type: 'UPDATE_SERVICE_ID',
      payload: { serviceId: _id },
    });
    navigate(`/service/category`);
  };
  const itemsPerPage = 3;
  const totalPages = Math.ceil(totalItems / itemsPerPage);
  return {
    isLoading,
    handleButtonClick,
    handlePageChange,
    totalPages,
    currentPage,
    totalItems,
    service,
    TextWeight,
  };
};
